var pxToNumber = function (px) {
    return Number(px.replace('px', ''));
};
export { pxToNumber };
